import { aiServicesData } from "@/mocks/aiSolutionsData";
import AnimatedSection from "@/components/AnimatedSection";

export default function AiServicesSection() {
  return (
    <section id="ai-services" className="py-16 md:py-24 bg-background-50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3 font-heading tracking-tight">
              {aiServicesData.heading}
            </h2>
            <div className="w-16 h-1 rounded-full mx-auto bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {aiServicesData.subtext}
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {aiServicesData.items.map((service, i) => (
            <AnimatedSection key={service.title} delay={i * 80}>
              <div className="h-full flex flex-col rounded-2xl border border-background-200/80 bg-background-100 p-6 card-lift hover:border-background-300/80">
                <div
                  className={`w-12 h-12 rounded-xl bg-gradient-to-br ${service.gradient} text-background-50 flex items-center justify-center mb-5 shadow-lg`}
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${service.icon} text-xl`} />
                  </span>
                </div>
                <h3 className="text-base font-bold text-foreground-950 font-heading mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {service.desc}
                </p>
                <ul className="mt-auto flex flex-col gap-2 pt-3 border-t border-background-200/70">
                  {service.points.map((point) => (
                    <li key={point} className="flex items-center gap-2 text-xs text-foreground-500">
                      <span className="w-3.5 h-3.5 flex items-center justify-center text-accent-500 shrink-0">
                        <i className="ri-check-line" />
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}